interface TrackingMapOverlayProps {
  isLive: boolean;
  isStale: boolean;
  lastUpdated: string | null;
}

export default function TrackingMapOverlay({
  isLive,
  isStale,
  lastUpdated,
}: TrackingMapOverlayProps) {
  const timeLabel = lastUpdated
    ? new Date(lastUpdated).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="absolute top-3 left-3 right-3 flex flex-wrap items-start justify-between gap-2 pointer-events-none z-10">
      <div className="flex flex-wrap gap-2">
        {isLive && (
          <span className="inline-flex items-center gap-1.5 bg-white/95 backdrop-blur-sm text-primary text-xs font-bold px-3 py-1.5 rounded-full shadow-sm border border-primary/15">
            <span className="material-symbols-outlined text-[14px] animate-pulse">
              radio_button_checked
            </span>
            Live
          </span>
        )}
        {isStale && (
          <span className="inline-flex items-center gap-1 bg-amber-50/95 text-amber-800 text-xs font-semibold px-3 py-1.5 rounded-full border border-amber-200">
            Location may be delayed
          </span>
        )}
      </div>
      {timeLabel && (
        <span className="text-[11px] font-medium text-slate-600 bg-white/90 px-2.5 py-1 rounded-lg shadow-sm">
          Updated {timeLabel}
        </span>
      )}
    </div>
  );
}
